import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TokenStorageService } from 'src/app/services/token-storage.service';
import { UserService } from 'src/app/services/user.service';
import { environment } from "src/environments/environment";
@Component({
  selector: 'app-view-kyc-details',
  templateUrl: './view-kyc-details.component.html',
  styleUrls: ['./view-kyc-details.component.scss']
})
export class ViewKycDetailsComponent implements OnInit {
  loading: boolean;
  paginationOption;
  totalRecords: 0;
  bankDetailsId: any;
  kycVerificationComplete: boolean=false;
  kycDetails: any;
  public loggedInUser;
  public isLoggedIn: boolean;
  public userId;
  constructor(
    private router: Router,
    private route: ActivatedRoute,
    private userService: UserService,
    private tokenStorage: TokenStorageService,

  ) { }

  ngOnInit(): void {
    this.paginationOption = environment.pagination;
    this.loggedInUser = this.tokenStorage.getUser();
    if (this.loggedInUser.userdata != undefined) {
      this.isLoggedIn = true;
      this.userId = this.loggedInUser.userdata.id;
      // if (this.loggedInUser.userdata.aadharVerificationCompleted === true) {
      //   this.aadharVerificationCompleted = true;
      // }
    }
    // this.bankDetailsId = this.route.snapshot.params.bankId;
    this.getSingleBankDetails(this.userId);
  }
  async getSingleBankDetails(userId) {
    let query = "?filterByDisable=false&filterByStatus=true&filterByuserId=" + userId +"&filterByPrimary=true" ;
    this.userService.getUserKycDetailsList(query).subscribe(
      res => {
        console.log(res);
      if (res.items.length > 0) {
        this.kycDetails = res.items.map(bankData => {
            if (bankData && bankData.bankData && bankData.bankData.length > 0) {
                bankData.bankData[0]['bankAccountNumber'] = this.maskAccountNumber(bankData.bankData[0]['bankAccountNumber']);
            }
            return bankData;
        });
    }
    
      if(res.items.length>0){
        this.kycDetails=res.items.map(bankData => {
        
          if (bankData.panCardNumber) {
            bankData.panCardNumber = this.maskAccountNumber( bankData.panCardNumber);
          }
          return bankData;
          });
      }

      if(res.items.length>0){
        this.kycDetails=res.items.map(bankData => {
          if (bankData.aadhaarCardNumber) {
            bankData.aadhaarCardNumber = this.maskAccountNumber( bankData.aadhaarCardNumber);
          }
          return bankData;
          });
      }

      
      
      },
      err => {
      }
    );
  }

  maskAccountNumber(accountNumber: string): string {
    if (!accountNumber) {
    return '';
    }
    
    const maskedPart = 'X'.repeat(accountNumber.length - 2);
    return maskedPart + accountNumber.slice(-2);
    }
}
